<div class="form-select-with-errors" #wrapper>
  @if (label()) {
    <label [for]="id()" class="form-select-with-errors__label">
      {{ label() | translate }}
      @if (control().hasValidator('required')) {
        <span class="form-select-with-errors__required" aria-label="required">*</span>
      }
    </label>
  }

  <div class="form-select-with-errors__wrapper">
    <div
      [id]="id()"
      role="button"
      [attr.tabindex]="disabled() ? -1 : 0"
      class="form-select-with-errors__trigger"
      [class.form-select-with-errors__trigger--active]="selectActive"
      [class.form-select-with-errors__trigger--error]="shouldShowError"
      [class.form-select-with-errors__trigger--disabled]="disabled()"
      [attr.aria-disabled]="disabled()"
      [attr.aria-invalid]="shouldShowError"
      [attr.aria-describedby]="shouldShowError ? id() + '-error' : null"
      [attr.aria-expanded]="selectActive"
      [attr.aria-haspopup]="true"
      (click)="onClickSelect()"
      (keydown)="onKeydownSelect($event)"
    >
      <span 
        class="form-select-with-errors__trigger-text"
        [class.form-select-with-errors__trigger-text--placeholder]="!selectedOption"
        [class.form-select-with-errors__trigger-text--hidden]="selectActive"
      >
        {{ selectedText | translate }}
      </span>
      @if (selectActive && searchInput) {
        <button
          type="button"
          class="form-select-with-errors__clear-button"
          (click)="onClearSearch($event)"
          aria-label="{{ 'Clear search' | translate }}"
        >
          <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
        </button>
      }
      <svg
        class="form-select-with-errors__trigger-icon"
        [class.form-select-with-errors__trigger-icon--open]="selectActive"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    @if (selectActive) {
      <input
        class="form-select-with-errors__search-input"
        type="text"
        [value]="searchInput"
        (input)="onSearchInput($event)"
        (keydown)="onKeydownSearchInput($event)"
        placeholder="{{ 'Search...' | translate }}"
      />

      <ul 
        class="form-select-with-errors__dropdown"
        role="listbox"
        [attr.aria-labelledby]="id()"
      >
        @if (filteredOptions.length === 0) {
          <li class="form-select-with-errors__no-results" role="status" translate>
            No results found
          </li>
        } @else {
          @for (option of filteredOptions; track trackByValue($index, option)) {
            <li
              #optionItem
              class="form-select-with-errors__option"
              [class.form-select-with-errors__option--selected]="option.selected"
              role="option"
              [attr.aria-selected]="option.selected"
              tabindex="0"
              (click)="onChangeSelect(option)"
              (keydown.enter)="onChangeSelect(option)"
              (keydown.space)="onChangeSelect(option); $event.preventDefault()"
              (keydown.arrowdown)="onKeydownOption($event)"
              (keydown.arrowup)="onKeydownOption($event)"
              (keydown.escape)="selectActive = false; searchInput = ''"
              (keydown)="onKeydownOptionPrintable($event)"
            >
              {{ option.text | translate }}
            </li>
          }
        }
      </ul>
    }
  </div>

  @if (shouldShowError) {
    <div 
      [id]="id() + '-error'" 
      class="form-select-with-errors__error"
      role="alert"
      aria-live="polite"
    >
      <i class="fa fa-exclamation-triangle form-select-with-errors__error-icon" aria-hidden="true"></i>
      <span class="form-select-with-errors__error-text">{{ errorMessage | translate }}</span>
    </div>
  }
</div>
